import React, { useState, useEffect, useContext } from 'react';


import { ExamContext } from '../context/ExamContext'

type ExamInfoProps = {
    showType: "exam" | "ques"
}

const ExamInfo = (props: ExamInfoProps) => {

    const ec = useContext(ExamContext)


    useEffect(() => {
    }, [ec.examInfo])

    return (
        <div className='exam-info'>
            <div className='title'>
                {ec.examInfo.title}
            </div>
            <div className='infos'>
                {
                    props.showType == "exam" && ec.examInfo.ExamType != "3" &&
                    <>
                        <div>
                            <span>
                                測驗時間
                            </span>
                            <span>
                                {ec.examInfo.TestMinute}分鐘
                            </span>
                        </div>
                        
                        <div>
                            <span>
                                完成時間
                            </span>
                            <span>
                                {ec.examInfo.LastUpdate ? ec.examInfo.LastUpdate : "無"}
                            </span>
                        </div>
                        <div>
                            <span>
                                備註
                            </span>
                            <span>
                                <pre>
                                    {ec.examInfo.Memo}
                                </pre>
                            </span>
                        </div>
                    </>
                }
            </div>
        </div>
    )
}


export default ExamInfo